import Axios from "axios";

export default function ViewCompleteSeatData(counsellingYear,selectedRound,selectedType,selectedEntrance){
    console.log(counsellingYear,selectedRound,selectedType,selectedEntrance);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a:'viewCompleteSeatData22',
            counsellingYear,
            selectedRound,
            selectedType,
            selectedEntrance                     
        }
    });
    return response;
}